export const styles = theme => ({
  root: {
  },
  photo: {
    width: 200,
    borderRadius: 100,
    border: "3px solid #ddd",
    margin: "0 auto",
    display: "block",
  },
  name: {
    color: "#fff",
    textAlign: "center",
    fontSize: 25,
    margin: "20px 0",
  },
  description: {
    color: "#fff",
    textAlign: "center",
    margin: 20,
    fontSize: 13,
  },
  contact: {
    color: "#fff",
    textAlign: "center",
    fontSize: 25,
    margin: "60px 0 20px 0",
    width: "100%"
  },
  link: {
    color: "#fff",
    textAlign: "center",
    fontSize: 25,
    margin: "20px 0",
    width: "100%"
  }
});